class Emitter {
    events = {};
    on(event, listener) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(listener);
    }
    emit(event, ...arguments_) {
        if (this.events[event]) {
            for (const listener of this.events[event]) {
                listener(...arguments_);
            }
        }
    }
}
export default Emitter;
